import { getColor } from 'utils';
import styled, { css } from 'styled-components';
import { FovSlider } from 'components/form';
import constants from 'constants/index';

const light = constants.THEME.LIGHT;

export const FormDiv = styled('div')`
  width: 100%;
`;

export const Label = styled('label')`
  width: 100%;
`;

export const ToggleContainer = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin: 0;
`;

export const TagsContainer = styled('div')`
  display: flex;
  width: 100%;
  box-sizing: border-box;
  border-radius: ${props => (props.$opened ? '0.25rem 0.25rem 0 0;' : '0.25rem')};
  border: 0.0625rem solid ${props => getColor(props, 'mediumGrey')};
  padding: 0.25rem;
`;

export const HeightContainer = styled('div')`
  display: grid;
  gap: 0 1rem;
  grid-template-columns: 1fr 6rem;
  width: 100%;
`;

export const AvailLink = styled('span')`
  color: ${props => getColor(props, 'accent')};
  cursor: pointer;

  &:hover {
    color: ${props => getColor(props, 'accentHover')};
  }
`;

export const AvailChannelsContainer = styled('div')`
  position: relative;
`;

export const LabeledSliderContainer = styled('div')`
  display: flex;
  justify-content: space-between;
  margin: 1.25rem 0;
`;

export const OptimizationControlContainer = styled('div')`
  display: flex;
  flex-direction: column;
  margin-top: 1rem;
`;

export const OptimizationTogglesContainer = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const MeshControl = styled('div')`
  display: grid;
  gap: 0.25rem 2rem;
  align-items: center;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(2, auto);
  grid-template-areas:
    'slider'
    'checkbox';

  width: 100%;
`;

export const MeshCheckbox = styled('label')`
  display: inline-flex;
  grid-area: checkbox;
`;

export const Slider = styled(FovSlider)`
  width: 100%;
  grid-area: slider;
`;

export const FormatsFieldLabel = styled('div')`
  display: flex;
  align-items: center;
  width: 100%;

  ${props => props.$compact && css`
    margin: 0.625rem 0 0.25rem;
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: ${props.$selectedTheme === light ? getColor(props, 'darkGrey') : '#9aa7b0'};
  `}
`;

export const FormatsControl = styled('div')`
  position: relative;
  width: 100%;
`;

export const FormatsValueBox = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  width: 100%;
  box-sizing: border-box;
  min-height: 2.69625rem;
  padding: 0.25rem 0.75rem 0.25rem 0.5rem;
  border-radius: 0.25rem;
  background: transparent;
  cursor: pointer;
  border: 0.0625rem solid ${props => (
    props.$opened ? getColor(props, 'accent') : getColor(props, 'mediumGrey')
  )};
  box-shadow: ${props => (
    props.$opened ? `0 0 0 0.0625rem ${getColor(props, 'accent')}` : 'none'
  )};

  ${props => props.$compact && css`
    min-height: 2.25rem;
    padding: 0.1875rem 0.5rem;
    border-radius: 0.375rem;
  `}
`;

export const FormatsTags = styled('div')`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  gap: 0.25rem;
  flex: 1;
  min-width: 0;
  overflow: hidden;
`;

export const FormatTag = styled('div')`
  display: inline-flex;
  align-items: center;
  font-size: 0.9rem;
  padding: 0.125rem 0.25rem 0.125rem 0.5rem;
  border-radius: 0.3125rem;
  white-space: nowrap;
  user-select: none;
  color: ${props => getColor(props, 'onPrimary')};
  background-color: ${props => getColor(props, 'lightGrey')};

  ${props => props.$compact && css`
    font-size: 0.8125rem;
  `}
`;

export const FormatTagRemove = styled('span')`
  display: inline-flex;
  align-items: center;
  margin-left: 0.25rem;
  cursor: pointer;
  color: ${props => getColor(props, 'onPrimary')};
`;

export const FormatsPlaceholder = styled('span')`
  color: ${props => getColor(props, 'mediumGrey')};
  font-size: 0.95rem;
`;

export const FormatsArrow = styled('div')`
  display: flex;
  align-items: center;
  pointer-events: none;
  transition: transform 0.15s ease;
  transform: rotate(${props => (props.$opened ? '180deg' : '0deg')});
`;

export const FormatsPopover = styled('div')`
  position: fixed;
  top: ${props => props.$top}px;
  left: ${props => props.$left}px;
  width: ${props => props.$width}px;
  z-index: 9999;
  box-sizing: border-box;
  padding: 0.75rem 1rem;
  max-height: 18rem;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  border-radius: 0 0 0.25rem 0.25rem;
  background-color: ${props => {
    const lightTheme = props.$selectedTheme === light;
    return getColor(props, lightTheme ? 'white' : 'darkGrey');
  }};
  box-shadow: 0 0.1rem 0.25rem ${props => {
    const lightTheme = props.$selectedTheme === light;
    return getColor(props, lightTheme ? 'darkGrey' : 'black');
  }};

  ${props => props.$compact && css`
    padding: 0.625rem 0.75rem;
  `}
`;

export const FormatsGrid = styled('div')`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-auto-flow: column;
  grid-template-rows: repeat(${props => props.$rows}, auto);
  gap: 0.75rem 1.5rem;

  ${props => props.$compact && css`
    grid-template-columns: 1fr;
    grid-auto-flow: row;
    grid-template-rows: none;
    gap: 0.625rem;
  `}
`;

export const FormatsTooltipContainer = styled('div')`
  width: 14rem;
`;